import React from 'react'

export default (props) => {
  return <span className={`loading-spinner loading-${props.type}`}>
    <i /><i /><i />
  </span>
}



// WEBPACK FOOTER //
// ./app/components/Loading.js